/*eslint-disable*/ export const messages = JSON.parse("{\"textfield.label.optional\":[\"(valfritt)\"]}");
//# sourceMappingURL=messages.mjs.map